<template>
    <div class='radio' :class='{checked:checked,disabled:disabled}'>
        
    </div>
</template>
<script>

export default {
    componentname: "radio",
    props:{
        disabled : {
            type : Boolean,
            default:false,
        },
        checked:{
            type : Boolean,
            default:false,
        }
    },
    setup(props){
        console.log(props.disabled)
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .radio{
        width: 14px;
        height: 14px;
        border-radius:15px;
        border: 0.5px solid #979797;
    }
    .checked{
        border: none;
        background: #3999FB;
        box-shadow: 0px 0px 10px 0px rgba(58, 153, 252, 0.35);
    }

    .disabled{
        background:#999!important;
    }

</style>

